import { Injectable } from '@angular/core';
import { take, tap } from 'rxjs/operators';
import { CostCenterListStore } from './cost-center-list.store';
import { CostCenterListQuery } from './cost-center-list.query';
import { FilterService } from '../../interfaces/filter/filter-service';
import { LocalStoreConfigModel } from '../../models/local-store-config.model';
import { ISavedListSettingsService } from '../../interfaces/settings/saved-list-settings.service';
import { state } from '@angular/animations';
import { TableColumn } from '../../models/table-column';
import { CostCenterListParams } from '../../models/client-models';

@Injectable({
  providedIn: 'root',
})
export class CostCenterListService
  implements FilterService, ISavedListSettingsService
{
  constructor(
    private costCenterListStore: CostCenterListStore,
    private costCenterListQuery: CostCenterListQuery
  ) {}

  setFilter(params: CostCenterListParams) {
    this.costCenterListQuery.filterOptions$
      .pipe(take(1))
      .subscribe((values) => {
        params.name = values.name.selected;
        params.number = values.number.selected;
        params.filterAll = !values.name.selected && !values.number.selected;
      });
    return params;
  }

  clearFilterValue() {
    this.costCenterListStore.update((state) => ({
      ...state,
      filterValue: '',
    }));
  }

  filterValueChange(filterValue: string) {
    this.costCenterListStore.update((state) => ({
      ...state,
      filterValue,
    }));
  }

  setFilterOptions(
    filterSelection: any,
    storeConfig?: LocalStoreConfigModel
  ): void {
    this.costCenterListStore.update((state) => ({
      ...state,
      filterOptions: filterSelection,
    }));
  }

  showSelectedColumns(
    columns: TableColumn[],
    storeConfig?: LocalStoreConfigModel
  ): void {
    this.costCenterListStore.update((state) => ({
      ...state,
      columns,
    }));
  }
}
